export default {
  items: [
    {
      _name: 'CSidebarNav',
      _children: [
        {
          _name: 'CSidebarNavItem',
          name: 'Trang chủ',
          icon: 'cil-speedometer',
          to: '/dashboard.html'
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Quản lý thiết bị',
          icon: 'cil-devices',
          to: '/devices-management/list.html'
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Thao tác phát thanh',
          icon: 'cil-bullhorn',
          items: [
            {
              // _name: 'CSidebarNavItem',
              name: 'Phát thanh trực tiếp',
              // icon: 'cib-livestream',
              to: '/devices-management/livestream.html'
            },
            {
              name: 'Phát thanh đặt lịch',
              to: '/schedule-management/managed-shedule.html',
            },
            {
              name: 'Xử lý lịch trùng',
              to: '/schedule-management/managed-duplicate.html',
            },
            {
              name: 'Nhật ký phát thanh',
              to: '/history-management/managed-history.html',
            },
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản lý ND & biên tập',
          icon: 'cil-file',
          items: [
            {
              name: 'Biên tập nội dung',
              to: '/files-management/managed-files.html',
            },
            {
              name: 'Chuyển đổi văn bản sang giọng nói',
              to: '/files-management/text-to-speech.html',
            },
            {
              name: 'Ghi âm giọng nói',
              to: '/files-management/record-files.html',
            },
            {
              name: 'Ghép tệp tin âm thanh',
              to: '/files-management/merge-files.html',
            },
            // {
            //   name: 'Biên tập danh sách phát',
            //   to: '/files-management/play-list.html',
            // },
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản trị',
          icon: 'cil-settings',
          items: [
            {
              name: 'Nhật ký hoạt động',
              to: '/administrator/user-activity-log.html',
            },
            {
              name: 'Quản lý lĩnh vực',
              to: '/administrator/file-type.html',
            },
            {
              name: 'Quản lý tiến trình',
              to: '/administrator/thread.html',
            },  
            // {
            //   name: 'Quản lý Cache',
            //   to: '/administrator/cache.html',
            // },
            {
              name: 'Quản lý kênh số hóa',
              to: '/administrator/channel-digital.html',
            },
            {
              name: 'Quản lý Key',
              to: '/administrator/key-authentication.html',
            },
            {
              name: 'Quản lý SIM',
              to: '/administrator/sim.html',
            },
            {
              name: 'Quản lý thông tin xác thực TB',
              to: '/administrator/config-authentication.html',
            },
            // {
            //   name: 'Upload kiểm tra loa',
            //   to: '/administrator/sound-speaker.html',
            // },
          ]
        },
        // {
        //   _name: 'CSidebarNavDropdown',
        //   name: 'Quản lý tài khoản',
        //   icon: 'cil-people',
        //   items: [
        //     {
        //       name: 'Danh sách tài khoản',
        //       to: '/user-management/managed-users.html',
        //     },
        //     {
        //       name: 'Đổi mật khẩu',
        //       // icon: 'cil-user',
        //       to: '/user/reset-password.html'
        //     },
        //   ]
        // },
        {
          _name: 'CSidebarNavItem',
          name: 'Hướng dẫn sử dụng',
          icon: 'cil-hd',
          to: '/user-manual.html'
        },
      ]
    },
  ]
}
